module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"edit-label":"Modifier","cancel-label":"Annuler","save-label":"Sauvegarder"},"en":{"edit-label":"Edit","cancel-label":"Cancel","save-label":"Save"}}')
  delete Component.options._Ctor
}
